/* eslint-disable prettier/prettier */
import { createStore } from "vuex";
import { appTranslation } from "@/services/Translation";

const buildProductList = (obj) => {
  const color = {
    1: "#13B3C1",
    2: "#ffe3b8",
    3: "#FFD363",
    4: "#fee2ff",
    5: "#deffd6",
  };
  const product = [];
  let index = 1;
  const slugMap = {
    1: "GrowthIQ",
    2: "Contextual GPT",
    3: "Inventory Management",
  };

  while (obj[`product_${index}_title`]) {
    product?.push({
      slug: slugMap[index] || `product-${index}`,
      color: color[index] || "#fee2ff",
      title: obj[`product_${index}_title`],
      description: obj[`product_${index}_description`],
      image: obj[`product_${index}_image`],
      content_title: obj[`product_${index}_content_title`],
      content_image: obj[`product_${index}_content_image`],
      content_description: obj[`product_${index}_content_description`],
      feature: obj.product_feature,
      product_feature_description: obj[`product_${index}_feature_description`],
      product_feature_1: obj[`product_${index}_feature_1`],
      product_feature_1_des: obj[`product_${index}_feature_1_des`],
      product_feature_2: obj[`product_${index}_feature_2`],
      product_feature_2_des: obj[`product_${index}_feature_2_des`],
      product_feature_3: obj[`product_${index}_feature_3`],
      product_feature_3_des: obj[`product_${index}_feature_3_des`],
      product_feature_4: obj[`product_${index}_feature_4`],
      product_feature_4_des: obj[`product_${index}_feature_4_des`],
      product_connect_title: obj[`product_${index}_connect_title`],
      product_connect_des: obj[`product_${index}_connect_des`],
      product_connect_button: obj[`product_${index}_connect_button`],
    });
    index++;
  }

  return product;
};

const flattenTranslations = (trns, lang) => {
  const obj = {};

  Object.keys(trns || {}).forEach((key) => {
    obj[key] = trns[key][lang];
  });

  return obj;
};

export default createStore({
  state: {
    dataTrans: {},
    translation: {},
    dataTranslation: {},
    trans: {},
    loading: false,
    productList: [],
  },
  getters: {},
  mutations: {
    setProductList: (state, payload) => {
      state.productList = payload;
    },
    setTranslationData: (state, payload) => {
      state.dataTrans = payload;
    },
    setLoading: (state, payload) => {
      state.loading = payload;
    },
    setLang: (state, payload) => {
      state.translation = payload;
    },
    setTransData(state, payload) {
      state.dataTranslztion = payload;
    },
    setLang2(state, payload) {
      state.trans = payload;
    },
  },
  actions: {
    async setTranslations({ commit }) {
      const lang = localStorage.getItem("lang") || "en";
      const applyTranslations = (trns) => {
        if (!trns) return;

        const obj = flattenTranslations(trns, lang);

        commit("setProductList", buildProductList(obj));
        commit("setLang2", obj);
      };

      try {
        const cachedTranslations = localStorage.getItem("lang2");

        if (cachedTranslations) {
          applyTranslations(JSON.parse(cachedTranslations));
        }
      } catch (error) {
        localStorage.removeItem("lang2");
      }

      try {
        const trns = await appTranslation();

        if (trns) {
          localStorage.setItem("lang2", JSON.stringify(trns));
          applyTranslations(trns);
        }
      } catch (error) {
        console.error("setTranslations error:", error);
      }
    },

    setLanguage({ state, commit }, lang = "en") {
      const object = state?.dataTrans;
      const data = {};

      for (const key in object) {
        const dataArray = object[key];

        if (key === "Home") {
          const makeObj = {};
          dataArray?.forEach((item) => {
            for (const key1 in item) {
              makeObj[key1] = item[key1][lang];
            }
          });
          data[key] = makeObj;
        } else {
          const profiles = dataArray.map((item) => item);
          data[key] = profiles;
        }
      }

      commit("setLang", data);
    },
  },
  modules: {},
});
